import axiosConfig from "./axiosConfig";

class DashService {
  constructor() {
    this.baseUrl = "/v1/dashboard/stats";
  }

  /**
   * Récupère les statistiques pour le dashboard à partir de l'API /v1/dashboard/stats
   * @returns {Promise<Object>} Les compteurs pour le dashboard
   */
  async getStats() {
    try {
      const resp = await axiosConfig.get(this.baseUrl);
      const data = resp.data?.data || {};

      // Articles section: récupère tous les champs utiles
      const articlesStats = data.articles || {};
      const articles = {
        total: articlesStats.total || 0,
        nouveau: articlesStats.nouveau || 0,
        partage_comite: articlesStats.partage_comite || 0,
        en_cours_evaluation: articlesStats.en_cours_evaluation || 0,
        revision_demande: articlesStats.revision_demande || 0,
        accepte_publication: articlesStats.accepte_publication || 0,
        published: articlesStats.published || 0,
        rejet: articlesStats.rejet || 0,
        passe_secretaire: articlesStats.passe_secretaire || 0,
      };

      // Users section: récupère tous les champs
      const usersStats = data.users || {};
      const users = {
        total: usersStats.total || 0,
        admins: usersStats.admins || 0,
        secreataires: usersStats.secreataires || 0,
        comites: usersStats.comites || 0,
        authors: usersStats.authors || 0,
      };

      // Affiliations section
      const affiliationsStats = data.affiliations || {};
      const affiliations = {
        total: affiliationsStats.total || 0,
        valid: affiliationsStats.valid || 0,
        invalid: affiliationsStats.invalid || 0,
      };

      // Rubriques section
      const rubriquesStats = data.rubriques || {};
      const rubriques = {
        total: rubriquesStats.total || 0,
      };

      return {
        articles,
        users,
        affiliations,
        rubriques,
      };
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des stats du dashboard:",
        error
      );
      return {
        articles: {
          total: 0,
          nouveau: 0,
          partage_comite: 0,
          en_cours_evaluation: 0,
          revision_demande: 0,
          accepte_publication: 0,
          published: 0,
          rejet: 0,
          passe_secretaire: 0,
        },
        users: {
          total: 0,
          admins: 0,
          secreataires: 0,
          comites: 0,
          authors: 0,
        },
        affiliations: {
          total: 0,
          valid: 0,
          invalid: 0,
        },
        rubriques: {
          total: 0,
        },
      };
    }
  }
}

const dashServiceInstance = new DashService();
export default dashServiceInstance;
